/*@ngInject*/
const ConfigurationMediator = function (dataSetActionRepository, dataSetBrowserActionRepository, dataSetManagementUtil, dataSetRepository, dataSetType,
                                        fieldReferencesRepository, fieldRuleBuilderRepository, formReferencesRepository, formActionRepository, formTemplateBrowserActionRepository,
                                        formTemplateSetRepository, formRuleBuilderRepository, objectRepository, uiFormTemplateRepository,
                                        rulesBrowserActionRepository, ruleRepository, ruleActionRepository, productTemplateBrowserActionRepository,
                                        productTemplateRepository, productTemplateEditorRepository, organizationBrowserActionRepository,
                                        organizationRepository, permissionsRepository, backupRepository, restoreRepository, popupNotificationRepository, emailNotificationRepository,
                                        sectionTemplateBrowserActionRepository, sectionTemplateRepository, sectionTemplateEditorRepository, sectionTemplateActionRepository,
                                        systemPreferencesManagerActionRepository, systemPreferencesRepository, scoringRulesRepository, userGroupEditorRepository,
                                        rateStatusRepository, importClassCodesRepository, filesAndIconsManagerActionRepository, filesAndIconsManagerRepository, generateDataDictionaryRepository) {

    this.createFormTemplate = function (uiFormTemplate) {
        return uiFormTemplateRepository.createFormTemplate(uiFormTemplate);
    };

    this.updateFormTemplate = function (uiFormTemplate, uiFormTemplateId) {
        return uiFormTemplateRepository.updateFormTemplate(uiFormTemplate, uiFormTemplateId);
    };

    this.getUiFormTemplatesByFilterUri = function (filterUri, requestParams) {
        return uiFormTemplateRepository.getUiFormTemplatesByFilterUri(filterUri, requestParams);
    };

    this.getFormTemplateById = function (formTemplateId) {
        return uiFormTemplateRepository.getUiFormTemplateById(formTemplateId);
    };

    this.getUIFormTemplatesByMatchingName = function (matchingName) {
        return uiFormTemplateRepository.getUIFormTemplatesByMatchingName(matchingName);
    };

    this.getFieldOptions = function (formTemplateUniqueName, fieldName) {
        return uiFormTemplateRepository.getFieldOptions(formTemplateUniqueName, fieldName);
    };

    this.getObjectNames = function (matchingName) {
        return objectRepository.getObjectNames(matchingName);
    };

    this.getObjectPropertyValues = function (objectName) {
        return objectRepository.getObjectPropertyValues(objectName);
    };

    this.getFieldRulesByUIFormTemplateId = function (uiFormTemplateId) {
        return uiFormTemplateRepository.getFieldRulesByUIFormTemplateId(uiFormTemplateId);
    };

    this.getFormReferences = function (uiFormTemplateId) {
        return formReferencesRepository.getFormReferences(uiFormTemplateId);
    };

    this.getFieldReferences = function (fieldTemplateId) {
        return fieldReferencesRepository.getFieldReferences(fieldTemplateId);
    };

    this.getRepeatingFormTemplateUniqueNames = function () {
        return uiFormTemplateRepository.getRepeatingFormTemplateUniqueNames();
    };

    this.loadUiFormTemplateActions = function (uri) {
        return formActionRepository.loadActions(uri);
    };

    this.loadFormTemplateBrowserActions = function () {
        return formTemplateBrowserActionRepository.loadActions();
    };

    this.publishFormTemplates = function (formTemplateIds) {
        return formTemplateSetRepository.publishFormTemplates(formTemplateIds);
    };

    this.publishFormTemplatesByFilterUri = function (filterUri, excludedFormTemplateIds) {
        return formTemplateSetRepository.publishFormTemplatesByFilterUri(filterUri, excludedFormTemplateIds);
    };

    this.createTestFormTemplateSet = function () {
        return formTemplateSetRepository.createTestFormTemplateSet();
    };

    this.createFormTemplate = function (uiFormTemplate) {
        return uiFormTemplateRepository.createFormTemplate(uiFormTemplate);
    };

    this.updateFormTemplate = function (uiFormTemplate, id) {
        return uiFormTemplateRepository.updateFormTemplate(uiFormTemplate, id);
    };

    this.deleteUIFormTemplate = function (uiFormTemplateId) {
        return uiFormTemplateRepository.deleteUIFormTemplates([uiFormTemplateId]);
    };

    this.deleteUIFormTemplates = function (uiFormTemplateIds) {
        return uiFormTemplateRepository.deleteUIFormTemplates(uiFormTemplateIds);
    };

    this.markFormTemplateInProduction = function (uiFormTemplateId) {
        return uiFormTemplateRepository.markFormTemplatesInProduction([uiFormTemplateId]);
    };

    this.markFormTemplatesInProduction = function (uiFormTemplateIds) {
        return uiFormTemplateRepository.markFormTemplatesInProduction(uiFormTemplateIds);
    };

    this.markFormTemplatesInProductionByFilterUri = function (filterUri, excludedUiFormTemplateIds) {
        return uiFormTemplateRepository.markFormTemplatesInProductionByFilterUri(filterUri, excludedUiFormTemplateIds);
    };

    this.importFormTemplates = function (file) {
        return uiFormTemplateRepository.importFormTemplates(file);
    };

    this.exportFormTemplate = function (formTemplateId) {
        return uiFormTemplateRepository.exportFormTemplates([formTemplateId]);
    };

    this.exportFormTemplates = function (formTemplateIds) {
        return uiFormTemplateRepository.exportFormTemplates(formTemplateIds);
    };

    this.exportFormTemplatesByFilterUri = function (filterUri, excludedFormTemplateIds) {
        return uiFormTemplateRepository.exportFormTemplatesByFilterUri(filterUri, excludedFormTemplateIds);
    };

    this.reloadFormRules = function (validate) {
        return uiFormTemplateRepository.reloadFormRules(validate);
    };

    this.reloadFieldRules = function (validate) {
        return uiFormTemplateRepository.reloadFieldRules(validate);
    };

    this.createDataSet = function (dataSet) {
        return dataSetRepository.createDataSet(dataSet);
    };

    this.deleteDataSet = function (name) {
        return dataSetRepository.deleteDataSet(name);
    };

    this.getDataSetsByFilterUri = function (filterUri, requestParams) {
        return dataSetRepository.getDataSetsByFilterUri(filterUri, requestParams);
    };

    this.getGeneratorDefinitions = function (type) {
        return dataSetRepository.getGeneratorDefinitions(type);
    };

    this.updateDataSet = function (dataSet, name) {
        // given a valid dataset, the last row of each group would have an "empty" data item
        // The empty data items need to be filtered out before saving, otherwise server will return a validation error
        // Same applies for sourceFieldDependencies
        const filteredItems = _.filter(dataSet.items, function (item) {
                return !dataSetManagementUtil.isEmptyDataItem(item);
            }),
            dependency = dataSet.dynamicDataSetDependency;

        if (dataSet.type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
            dataSet.enhancedDynamicDataItems = filteredItems;
            dataSet.dependency = dataSet.dynamicDataSetDependency;
        } else {
            dataSet.items = filteredItems;
        }

        if (!_.isNil(dependency)) {
            let filteredSourceFieldDependencies = _.filter(dependency.sourceFieldDependencies, function (sourceFieldDependency) {
                return dataSetManagementUtil.isValidSourceFieldDependency(sourceFieldDependency);
            });

            // Build the source field dependency keys
            _.each(filteredSourceFieldDependencies, function (sourceFieldDependency) {
                sourceFieldDependency.key = sourceFieldDependency.formTemplateUniqueName + '|' + sourceFieldDependency.fieldName;
            });

            dependency.sourceFieldDependencies = filteredSourceFieldDependencies;
        }

        if (dataSet.type === dataSetType.CUSTOM || dataSet.type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
            // Remove "no-op" dynamic data item criterion
            _.each(dataSet.items, function (dataItem) {
                dataItem.enhancedDynamicDataItemCriteriaList = _.filter(dataItem.enhancedDynamicDataItemCriteriaList, function (dynamicDataItemCriteria) {
                    return dataSetManagementUtil.isValidDynamicDataItemCriteria(dynamicDataItemCriteria);
                });
            });
        }

        return dataSetRepository.updateDataSet(dataSet, name);
    };

    this.loadDataSetBrowserActions = function () {
        return dataSetBrowserActionRepository.loadActions();
    };

    this.loadDataSetActionByName = function (uri) {
        return dataSetActionRepository.loadDataSetActionByName(uri);
    };

    this.getDataSetReferences = function (name) {
        return dataSetActionRepository.getReferences(name);
    };

    this.deleteDataSetByName = function (name, forceDelete) {
        return dataSetActionRepository.deleteDataSetByName(name, forceDelete);
    };

    this.getJsBuilderOptions = function (uiFormTemplateId) {
        return uiFormTemplateRepository.getJsBuilderOptions(uiFormTemplateId);
    };

    this.validateRule = function (rule) {
        return formRuleBuilderRepository.validateRule(rule);
    };

    this.validateRegExp = function (regExp, value) {
        return uiFormTemplateRepository.validateRegExp(regExp, value);
    };

    this.exportDataSetsByName = function (dataSetNames) {
        return dataSetRepository.exportDataSetsByName(dataSetNames);
    };

    this.exportDataSetsByNameWithFilter = function (filterUri, excludedDataSetNames) {
        return dataSetRepository.exportDataSetsByNameWithFilter(filterUri, excludedDataSetNames);
    };

    this.loadRulesBrowserActions = function () {
        return rulesBrowserActionRepository.loadActions();
    };

    this.loadRuleBuilderActions = function (uri) {
        return ruleActionRepository.loadRuleAction(uri);
    };

    this.getRulesByFilterUri = function (filterUri, requestParams) {
        return ruleRepository.getRulesByFilterUri(filterUri, requestParams);
    };

    this.redeployRuleSets = function (ruleSetIds) {
        return ruleRepository.redeployRuleSets(ruleSetIds);
    };

    this.dataSetBackup = function () {
        return dataSetRepository.dataSetBackup();
    };

    this.backupProducts = function () {
        return productTemplateRepository.backupProducts();
    };

    this.rulesBackup = function () {
        return ruleRepository.rulesBackup();
    };

    this.formTemplateBackup = function () {
        return uiFormTemplateRepository.formTemplateBackup();
    };

    this.findUIFieldByUIFormTemplateUniqueNameAndFieldName = function (uiFormTemplateUniqueName, fieldName) {
        return uiFormTemplateRepository.findUIFieldByUIFormTemplateUniqueNameAndFieldName(uiFormTemplateUniqueName, fieldName);
    };


    this.loadProductTemplateActions = function (productTemplateName) {
        return productTemplateBrowserActionRepository.loadActions(productTemplateName);
    };

    this.getProductTemplatesByFilterUri = function (filterUri, requestParams) {
        return productTemplateRepository.getProductTemplatesByFilterUri(filterUri, requestParams);
    };

    this.loadProductTemplateById = function (productTemplateId) {
        return productTemplateEditorRepository.loadProductTemplateById(productTemplateId);
    };

    this.loadOrganizationActions = function (organizationId) {
        return organizationBrowserActionRepository.loadActions(organizationId);
    };

    this.getOrganizationsByFilterUriAndOrganizationType = function (filterUri, organizationType, requestParams) {
        return organizationRepository.getOrganizationsByFilterUriAndOrganizationType(filterUri, organizationType, requestParams);
    };

    this.loadPermissionActions = function (userType) {
        return permissionsRepository.loadPermissionActions(userType);
    };

    this.updatePermissions = function (permissions) {
        return permissionsRepository.updatePermissions(permissions);
    };

    this.backupOrganizations = function () {
        return organizationRepository.backupOrganizations();
    };

    this.getAvailableConditionalFieldTemplateIds = function (uiFormTemplateId) {
        return fieldRuleBuilderRepository.getAvailableConditionalFieldTemplateIds(uiFormTemplateId);
    };

    this.createNewOrganization = function (organizationType) {
        return organizationBrowserActionRepository.createNewOrganization(organizationType);
    };

    this.importCarrierLOAs = function (file, isMga) {
        return organizationBrowserActionRepository.importCarrierLOAs(file, isMga);
    };

    this.exportCarrierLOAs = function (isMga) {
        return organizationBrowserActionRepository.exportCarrierLOAs(isMga);
    };

    this.backup = function (sectionName) {
        return backupRepository.backup(sectionName);
    };

    this.restore = function (operation, file) {
        return restoreRepository.restore(operation, file);
    };

    this.importClassCodes = function (file) {
        return importClassCodesRepository.importClassCodes(file);
    };

    this.loadPopupNotificationActions = function () {
        return popupNotificationRepository.loadPopupNotificationActions();
    };

    this.loadEmailNotificationActions = function () {
        return emailNotificationRepository.loadEmailNotificationActions();
    };

    this.loadStateRateActions = function () {
        return rateStatusRepository.loadActions();
    };

    this.loadStateRates = function (params) {
        return rateStatusRepository.loadStateRates(params);
    };

    this.saveStateRates = function (stateRates) {
        return rateStatusRepository.saveStateRates(stateRates);
    };

    this.loadEmailNotification = function (params) {
        return emailNotificationRepository.loadEmailNotification(params);
    };

    this.loadPopupNotification = function (params) {
        return popupNotificationRepository.loadPopupNotification(params);
    };

    this.loadSectionTemplateBrowserActions = function () {
        return sectionTemplateBrowserActionRepository.loadActions();
    };

    this.getSectionTemplatesByName = function (nameSearchString, requestParams) {
        return sectionTemplateRepository.getSectionTemplatesByName(nameSearchString, requestParams);
    };

    this.getSectionTemplateById = function (sectionTemplateId) {
        return sectionTemplateEditorRepository.getSectionTemplateById(sectionTemplateId);
    };

    this.loadSectionTemplateActions = function (sectionTemplateId) {
        return sectionTemplateActionRepository.loadSectionTemplateActions(sectionTemplateId);
    };

    this.saveSectionTemplate = function (sectionTemplate) {
        return sectionTemplateRepository.saveSectionTemplate(sectionTemplate);
    };

    this.deleteSectionTemplate = function (sectionTemplateId) {
        return sectionTemplateRepository.deleteSectionTemplate(sectionTemplateId);
    };

    this.markSectionTemplateInProduction = function (sectionTemplateId) {
        return sectionTemplateRepository.markInProduction(sectionTemplateId);
    };

    this.uploadQuoteDocumentTemplateFile = function (sectionTemplate, quoteDocumentTemplateFile) {
        return sectionTemplateRepository.uploadQuoteDocumentTemplateFile(sectionTemplate, quoteDocumentTemplateFile);
    };

    this.loadRecipients = function () {
        return emailNotificationRepository.loadRecipients();
    };

    this.loadSystemPreferencesManagerActions = function () {
        return systemPreferencesManagerActionRepository.loadActions();
    };

    this.loadScoringRulesActions = function (scoringRuleId) {
        return scoringRulesRepository.loadActions(scoringRuleId);
    };

    this.getScoringRulesByParam = function (requestParam) {
        return scoringRulesRepository.getScoringRulesByParam(requestParam);
    };

    this.getScoringRuleById = function (scoringRuleId) {
        return scoringRulesRepository.getScoringRuleById(scoringRuleId);
    };

    this.saveScoringRule = function (scoringRule) {
        return scoringRulesRepository.saveScoringRule(scoringRule);
    };

    this.deleteScoringRule = function (scoringRuleId) {
        return scoringRulesRepository.deleteScoringRule(scoringRuleId);
    };

    this.copyScoringRule = function (scoringRuleId) {
        return scoringRulesRepository.copyScoringRule(scoringRuleId);
    };

    this.loadUserGroupById = function (userGroupId) {
        return userGroupEditorRepository.loadUserGroupById(userGroupId);
    };

    this.getStudioPreferences = function () {
        return systemPreferencesRepository.getStudioPreferences();
    };

    this.saveStudioPreferences = function (studioPreferences) {
        return systemPreferencesRepository.saveStudioPreferences(studioPreferences);
    };

    this.loadFilesAndIconsManagerActions = function () {
        return filesAndIconsManagerActionRepository.loadActions();
    };

    this.getConfiguredFiles = function () {
        return filesAndIconsManagerRepository.getConfiguredFiles();
    };

    this.saveConfiguredFile = function (configuredFile) {
        return filesAndIconsManagerRepository.saveConfiguredFile(configuredFile);
    };

    this.deleteConfiguredFile = function (configuredFileId) {
        return filesAndIconsManagerRepository.deleteConfiguredFile(configuredFileId);
    };

    this.generateDataDictionary = function () {
        return generateDataDictionaryRepository.generateDataDictionary();
    }
};

angular.module('ums.configuration')
    .service('configurationMediator', ConfigurationMediator);
